import { BoxProps, TextNewProps, TextProps } from '@jfs/ui-new'
import { ViewProps } from 'react-native'

const styles = {
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    w: '100%',
  } as BoxProps,
  subContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    w: '100%',
    height: 50,
    zIndex: 80,
  } as BoxProps,
  wrap: {
    flexDirection: 'row',
    cursor: 'pointer',
    alignSelf: 'center',
    height: 50,
    flex: 1,
    width: '100%',
  } as BoxProps,
  inputBox: {
    width: '100%',
  } as BoxProps,
  input: {
    color: 'transparent',
    backgroundColor: 'transparent',
    width: '100%',
    zIndex: 100,
    outline: 'none',
    outlineColor: 'transparent',
    overflow: 'hidden',
    fontFamily: 'jiotype-medium',
  } as ViewProps,
  display: (highlightBottom: boolean) =>
    ({
      borderBottomWidth: highlightBottom ? 2 : 1,
      borderBottomColor: highlightBottom ? 'BLUE' : 'BRAND_COLOR_GRAY_1',
      f: 1,
      height: 30,
      margin: 9,
      paddingBottom: 6,
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    } as BoxProps),
  text: {
    fontSize: 24,
    color: 'BLACK_21',
    fontFamily: 'jioType-medium',
  } as TextProps,
  shadows: {
    borderBottomColor: 'BLUE',
    borderBottomWidth: 2,
  } as unknown as BoxProps,
  dot: {
    height: 12,
    width: 12,
    borderRadius: 6,
    backgroundColor: 'BLACK',
  } as BoxProps,
  error: {
    borderBottomColor: 'ERROR',
  } as BoxProps,
  resendText: {
    fontSize: 14,
    fontFamily: 'jiotype-medium',
    textDecorationLine: 'underline',
  } as TextNewProps,
  countText: {
    fontSize: 14,
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  timerText: {
    fontSize: 14,
    fontFamily: 'jiotype-medium',
    color: 'ORANGE',
    letterSpacing: 1,
  } as TextNewProps,
  errorView: {
    w: '100%',
    pt: 6,
  } as BoxProps,
  errorText: {
    type: 'body12',
    color: 'ERROR',
  } as TextNewProps,
}
export default styles
